/**
 * Enumeration of fields that can be bulk updated for tasks
 */ export var BulkUpdatableField = /*#__PURE__*/ function(BulkUpdatableField) {
    // Assignments field
    BulkUpdatableField["Assignments"] = "assignments";
    // Due date time field
    BulkUpdatableField["DueDateTime"] = "dueDateTime";
    // Start date time field
    BulkUpdatableField["StartDateTime"] = "startDateTime";
    // Priority field
    BulkUpdatableField["Priority"] = "priority";
    // Status field
    BulkUpdatableField["Status"] = "status";
    // Percent complete field (0..100)
    BulkUpdatableField["PercentComplete"] = "percentComplete";
    // Custom field (resolved via customFieldDefinitionId in the payload)
    BulkUpdatableField["CustomField"] = "customField";
    return BulkUpdatableField;
}({});
/**
 * Enum for assign mode
 */ export var AssignMode = /*#__PURE__*/ function(AssignMode) {
    // Assigning tasks to a user
    AssignMode[AssignMode["Assign"] = 0] = "Assign";
    // Unassigning tasks from a user
    AssignMode[AssignMode["Unassign"] = 1] = "Unassign";
    return AssignMode;
}({});
/**
 * Types of tasks that can be rendered in the gantt chart
 */ export var GanttTaskType = /*#__PURE__*/ function(GanttTaskType) {
    /** Regular task with start and end dates rendered as a bar */ GanttTaskType["Bar"] = "bar";
    /** Milestone task (single point in time, rendered as diamond) */ GanttTaskType["Milestone"] = "milestone";
    /** Summary task (groups child tasks, rendered as horizontal bar with vertical edges) */ GanttTaskType["Summary"] = "summary";
    return GanttTaskType;
}({});
